import { api } from "./api";

// In-memory + localStorage cache and a micro-batch queue so a whole feed of
// items translates in one /translate request instead of N.
const mem = {};
let queue = [];
let timer = null;

const LS_PREFIX = "hc_tr3:";
const lsGet = (k) => { try { return localStorage.getItem(LS_PREFIX + k); } catch { return null; } };
const lsSet = (k, v) => { try { localStorage.setItem(LS_PREFIX + k, v); } catch { /* quota */ } };

function chunk(arr, n) {
    const out = [];
    for (let i = 0; i < arr.length; i += n) out.push(arr.slice(i, i + n));
    return out;
}

async function flush() {
    const batch = queue;
    queue = [];
    timer = null;
    const byLang = {};
    batch.forEach((it) => { (byLang[it.lang] ||= []).push(it); });

    for (const [lang, items] of Object.entries(byLang)) {
        const uniq = [...new Set(items.map((i) => i.text))];
        const map = {};
        await Promise.all(chunk(uniq, 16).map(async (group) => {
            try {
                const { data } = await api.post("/translate", { texts: group, target: lang });
                group.forEach((t, i) => { map[t] = (data.translations || [])[i] ?? t; });
            } catch {
                group.forEach((t) => { map[t] = t; });
            }
        }));
        items.forEach((it) => {
            const tr = map[it.text] ?? it.text;
            mem[it.lang + ":" + it.text] = tr;
            lsSet(it.lang + ":" + it.text, tr);
            it.resolve(tr);
        });
    }
}

export function translateOne(text, lang) {
    if (!lang || lang === "en" || !text || !text.trim()) return Promise.resolve(text);
    const key = lang + ":" + text;
    if (mem[key]) return Promise.resolve(mem[key]);
    const ls = lsGet(key);
    if (ls) { mem[key] = ls; return Promise.resolve(ls); }
    return new Promise((resolve) => {
        queue.push({ text, lang, resolve });
        if (!timer) timer = setTimeout(flush, 120);
    });
}

export function translateTexts(texts, lang) {
    return Promise.all(texts.map((t) => translateOne(t, lang)));
}
